import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

export const slider = (): void => {
  // console.log('slider');
  const swiper = new Swiper('.p-ip-lead-slider__swiper', {
    modules: [Navigation, Pagination],
    autoHeight: true,
    // cssMode: true,
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: '.p-ip-lead-slider__btn.--next',
      prevEl: '.p-ip-lead-slider__btn.--prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
};
